<template>
  <div
    class="wrapper"
    :style="{ backgroundImage: bgImageUrl ? `url(${bgImageUrl})` : '' }"
  >
    <transition mode="out-in" name="fade">
      <Step1
        v-if="state.step === 0"
        :campaignData="state.campaignObj"
        @next="(e) => ((state.campaignObj = e), (e.nojob || !e.job) ? state.step+=2 : state.step++)"
      />
      <Step2
        v-else-if="state.step === 1"
        :campaignData="state.campaignObj"
        @prev="state.step--"
        @next="(e) => ((state.campaignObj = e), state.step++)"
      />
      <Step3
        v-else-if="state.step === 2"
        :campaignData="state.campaignObj"
        @prev="state.step-=2"
        @next="(e) => ((state.campaignObj = e), state.step++)"
      />
      <Step4
        v-else
        :campaignData="state.campaignObj"
        @prev="state.step--"
        @handleBGUpdate="updateBackgroundImage"
      />
    </transition>
  </div>
</template>

<script setup>
import { reactive, ref } from "vue";
import Step1 from "./partials/Step1.vue";
import Step2 from "./partials/Step2.vue";
import Step3 from "./partials/Step3.vue";
import Step4 from "./partials/Step4.vue";

const bgImageUrl = ref(null);

// Update the background image when the file is uploaded
const updateBackgroundImage = (imageUrl) => {
  bgImageUrl.value = imageUrl;
};

const state = reactive({
  step: 0,
  campaignObj: {},
});
</script>
